import * as $ from "jquery";

export const CustomFileExtensionRules = (() => {
    // @ts-ignore
    $.validator.addMethod("customFileExtension", $.validator.methods.extension,
        $.validator.format("Proszę o podanie wartości z prawidłowym rozszerzeniem - {0}")
    );
})();import * as $ from "jquery";

export const CustomFileExtensionRules = (() => {
    // @ts-ignore
    $.validator.addMethod("customFileExtension", $.validator.methods.extension,
        $.validator.format("Proszę o podanie wartości z prawidłowym rozszerzeniem - {0}")
    );
})();